import { OBaseModel } from '@olameter/o-utilities';
import { ContractImportedField } from 'src/app/proto/generated/inv_contract_imported_field_message_pb';

export class ContractImportedFieldModel implements OBaseModel {
  contractName: string;
  name: string;
  groupName: string;
  category: string;
  isMandatory: boolean;
  type: string;
  isExpectedField: boolean;
  isDeleted: boolean;

  static MapperList(
    references: ContractImportedField[]
  ): ContractImportedFieldModel[] {
    const ret: ContractImportedFieldModel[] = [];
    references?.forEach((reference) => {
      ret.push(ContractImportedFieldModel.Mapper(reference));
    });
    return ret;
  }

  static Mapper(source: ContractImportedField): ContractImportedFieldModel {
    const destination: ContractImportedFieldModel =
      new ContractImportedFieldModel();
    destination.contractName = source.getContractName();
    destination.name = source.getName();
    destination.groupName = source.getGroupName();
    destination.category = source.getCategory();
    destination.isMandatory = source.getIsMandatory();
    destination.type = source.getType();
    destination.isExpectedField = source.getIsExpectedField();
    destination.isDeleted = source.getIsDeleted();
    return destination;
  }
}
